var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex"},[_c('base-button',{staticClass:"m-0",attrs:{"link":""},on:{"click":_vm.back}},[_c('ArrowLeftIcon',{staticClass:"mr-2",attrs:{"size":"18"}}),_vm._v(" "+_vm._s(_vm.title)+" ")],1),_c('div',{staticClass:"flex-1"}),_vm._t("default")],2),_c('div',{staticClass:"h-divider"})])
}
var staticRenderFns = []

export { render, staticRenderFns }